import { forwardRef } from 'react';
import { Content, Place, SimpleModalButtons, SimpleModalTitle } from './simple-modal.styled';

export { SimpleModalButtons, SimpleModalTitle };

export const SimpleModal = forwardRef((props, ref) => {
  const { children, ...rest } = props;

  return (
    <Place onClick={(event) => event.stopPropagation()} {...rest} ref={ref}>
      <Content>{children}</Content>
    </Place>
  );
});
